import { ArrowLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ChangelogCreateForm } from '@admin/components/forms/changelogs/changelog-create-form.tsx';
import { LinkProtected } from '@r/components/link-protected/link-protected.tsx';
import { Button } from '@ui/button.tsx';

/**
 * Page Mega Admin « Rédiger une nouveauté » : création groupée d'un changelog
 * par cible depuis une seule catégorie.
 */
export function ChangelogCreate() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <LinkProtected
        to="/fiddy-admin/ressources/changelogs"
        className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
      >
        <Button rounded="full">
          <ArrowLeftIcon />
          {t('common.back')}
        </Button>
      </LinkProtected>

      <h1 className="text-4xl font-bold">{t('changelog.create.page.title')}</h1>
      <ChangelogCreateForm />
    </div>
  );
}
